import { ReportFileTypeEnum } from '../../../enums/ReportFileEnum';

/**
 * 解析下载记录页 URL `?type=`：风控日志导出跳转时带 51，其它（含缺省、非法值）一律回落到申诉审核导出，不报错。
 */
export const resolveDownloadType = (raw: string | null): ReportFileTypeEnum =>
    raw === String(ReportFileTypeEnum.DRIVER_ACTIVITY_RISK_LOG_EXPORT)
        ? ReportFileTypeEnum.DRIVER_ACTIVITY_RISK_LOG_EXPORT
        : ReportFileTypeEnum.APPEAL_REVIEW_EXPORT;
